const CallRejectedSound = "/assets/sounds/call-rejected.mp3";
const CallWaitingSound = "/assets/sounds/call-waiting.mp3";
const ConnectionWaitingSound = "/assets/sounds/connection-waiting.mp3";
const CallingRingtoneSound = "/assets/sounds/calling-ringtone.mp3";

export { CallRejectedSound, CallWaitingSound, ConnectionWaitingSound, CallingRingtoneSound };
